import { getURL } from '@domain/infrastructure/Urls';
import { getAssetURL } from '@domain/infrastructure/Urls';
import { getStaticURL } from '@domain/infrastructure/Urls';
import { getDomainDataURL } from '@domain/infrastructure/Urls';
import { getS3ResourceURL } from '@domain/infrastructure/Urls';
import { getWSURL } from '@domain/infrastructure/Urls';
import { getServiceURLserverSide } from '@domain/infrastructure/Urls';
import { PopulateEnvars } from './PopulateEnvars';

export {
    getURL,
    getAssetURL,
    getStaticURL,
    getDomainDataURL,
    getS3ResourceURL,
    getWSURL,
    getServiceURLserverSide,
    PopulateEnvars
};

export default {
    getURL,
    getAssetURL,
    getStaticURL,
    getDomainDataURL,
    getS3ResourceURL,
    getWSURL,
    getServiceURLserverSide,
    PopulateEnvars
};
